import { useState } from "react";
import { Linkedin, Presentation, Newspaper, ArrowUpRight, Play } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const LINKS = [
  [Linkedin, "Connect With Me on LinkedIn", "https://www.linkedin.com/in/jonesfreya", "linkedin"],
  [Presentation, "View My BrightonSEO Presentation", "https://www.slideshare.net/slideshow/brighton-seo-instagram-seo-tactics-to-be-seen/250180852", "slideshare"],
  [Newspaper, "Featured at BrightonSEO", "https://hallam.agency/blog/our-10-top-takeaways-from-brighton-seo/", "hallam"],
];

const VIDEOS = [
  { id: "SGzFga8nmbo", title: "Evergreen Advertising Strategies with Ad Expert Freya Jones", source: "Falcon Digital Marketing" },
  { id: "G79GXKypzQ8", title: "Five Psychological Tips to Help You Increase Conversion Rates in PPC", source: "PPC Live" },
];

const Video = ({ v }) => {
  const [play, setPlay] = useState(false);
  return (
    <figure className="overflow-hidden rounded-[24px] border border-violet-200 bg-white" data-testid={`video-${v.id}`}>
      <div className="relative aspect-video bg-[#13052A]">
        {play ? (
          <iframe className="absolute inset-0 h-full w-full" src={`https://www.youtube-nocookie.com/embed/${v.id}?autoplay=1&rel=0`} title={v.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
        ) : (
          <button onClick={() => setPlay(true)} className="group absolute inset-0 h-full w-full" aria-label={`Play video: ${v.title}`} data-testid={`video-play-${v.id}`}>
            <img src={`/img/yt-${v.id}.jpg`} alt="" loading="lazy" className="h-full w-full object-cover" />
            <span className="absolute inset-0 bg-[#13052A]/25 transition-colors group-hover:bg-[#13052A]/10" />
            <span className="absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-[#FF7043] text-[#13052A] shadow-xl transition-transform group-hover:scale-110">
              <Play className="ml-1 h-7 w-7 fill-current" />
            </span>
          </button>
        )}
      </div>
      <figcaption className="p-5">
        <p className="text-base font-extrabold leading-snug text-[#13052A]">{v.title}</p>
        <p className="mt-1 text-sm text-slate-500">{v.source} · YouTube</p>
      </figcaption>
    </figure>
  );
};

export const ProLinks = () => (
  <div className="mx-auto mt-16 max-w-7xl px-5 sm:mt-20 sm:px-8" data-testid="pro-links">
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {LINKS.map(([I, label, href, id], i) => (
        <Reveal key={id} delay={i * 0.05} className="h-full">
          <a href={href} target="_blank" rel="noopener noreferrer" data-testid={`pro-link-${id}`}
            className="group flex h-full min-h-[64px] items-center gap-3 rounded-2xl border border-violet-200 bg-white px-4 py-4 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-0.5 hover:border-[#7C3AED] hover:shadow-[0_20px_40px_-25px_rgba(46,16,101,.5)]">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#EDE9FE] text-[#581C87] transition-colors group-hover:bg-[#7C3AED] group-hover:text-white"><I className="h-5 w-5" /></span>
            <span className="flex-1 text-sm font-bold text-[#13052A]">{label}</span>
            <ArrowUpRight className="h-4 w-4 shrink-0 text-[#7C3AED]" />
          </a>
        </Reveal>
      ))}
    </div>
    <Reveal className="mt-14">
      <h3 className="text-2xl font-extrabold text-[#13052A] sm:text-3xl">Speaking, Insights & Videos</h3>
    </Reveal>
    <div className="mt-6 grid gap-5 md:grid-cols-2">
      {VIDEOS.map((v, i) => <Reveal key={v.id} delay={i * 0.08}><Video v={v} /></Reveal>)}
    </div>
  </div>
);
